import React from 'react';
import { ReactComponent as PDFIcon } from 'assets/file-pdf-regular.svg';

import {
  ArrowRightStartOnRectangleIcon,
  Bars3Icon,
  Cog8ToothIcon,
  CheckIcon,
  ChevronUpIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  LifebuoyIcon,
  UserIcon,
  StarIcon,
  PlusCircleIcon,
  XMarkIcon,
  LockClosedIcon,
  ArrowsRightLeftIcon,
  MagnifyingGlassIcon,
  EllipsisVerticalIcon,
  PlusIcon,
  MinusIcon,
  PhotoIcon,
  FolderArrowDownIcon,
  RocketLaunchIcon,
  ArrowLongRightIcon,
  ArrowPathIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/solid';

import {
  InformationCircleIcon,
  ExclamationTriangleIcon,
  ArchiveBoxIcon,
  BuildingStorefrontIcon,
  BuildingOfficeIcon,
  BuildingOffice2Icon,
  DocumentIcon,
  DocumentDuplicateIcon,
  DocumentTextIcon,
  DocumentCheckIcon,
  ClipboardDocumentListIcon,
  TrashIcon,
  ArrowDownTrayIcon,
  PencilSquareIcon,
  UsersIcon,
  CreditCardIcon,
  HomeIcon,
  AtSymbolIcon,
  BriefcaseIcon,
  BellIcon,
  InboxStackIcon,
  ClockIcon,
  TagIcon,
  KeyIcon,
  ArrowRightEndOnRectangleIcon,
  CalendarIcon,
  StarIcon as StarOutlineIcon,
  GlobeAltIcon,
  EyeIcon,
  EyeSlashIcon,
  MapIcon,
  ChartBarIcon,
  ArrowsRightLeftIcon as ArrowsRightLeftOutlineIcon,
} from '@heroicons/react/24/outline';

import { Box, useTheme } from '@mui/material';

const iconMap = {
  logOut: <ArrowRightStartOnRectangleIcon />,
  cog8Tooth: <Cog8ToothIcon />,
  lifebuoy: <LifebuoyIcon />,
  home: <HomeIcon />,
  star: <StarIcon />,
  starOutline: <StarOutlineIcon />,
  chevronUp: <ChevronUpIcon />,
  chevronRight: <ChevronRightIcon />,
  chevronLeft: <ChevronLeftIcon />,
  chevronDown: <ChevronDownIcon />,
  download: <ArrowDownTrayIcon />,
  downloadFile: <FolderArrowDownIcon />,
  edit: <PencilSquareIcon />,
  user: <UserIcon />,
  users: <UsersIcon />,
  circlePlus: <PlusCircleIcon />,
  plus: <PlusIcon />,
  minus: <MinusIcon />,
  xMark: <XMarkIcon />,
  lockClosed: <LockClosedIcon />,
  info: <InformationCircleIcon />,
  warning: <ExclamationTriangleIcon />,
  archive: <ArchiveBoxIcon />,
  marketplace: <BuildingStorefrontIcon />,
  menu: <ArrowsRightLeftIcon />,
  buildingOffice: <BuildingOfficeIcon />,
  buildingOffice2: <BuildingOffice2Icon />,
  document: <DocumentIcon />,
  documentDuplicate: <DocumentDuplicateIcon />,
  documentText: <DocumentTextIcon />,
  documentCheck: <DocumentCheckIcon />,
  clipboardDocumentList: <ClipboardDocumentListIcon />,
  search: <MagnifyingGlassIcon />,
  elipsisVertical: <EllipsisVerticalIcon />,
  trash: <TrashIcon />,
  photo: <PhotoIcon />,
  confirm: <CheckIcon />,
  pdf: <PDFIcon />,
  subscription: <CreditCardIcon />,
  bars3: <Bars3Icon />,
  rocket: <RocketLaunchIcon />,
  arrowRightLong: <ArrowLongRightIcon />,
  atSymbol: <AtSymbolIcon />,
  arrowPath: <ArrowPathIcon />,
  arrowsRightLeft: <ArrowsRightLeftOutlineIcon />,
  briefcase: <BriefcaseIcon />,
  bell: <BellIcon />,
  inboxStack: <InboxStackIcon />,
  arrowLeft: <ArrowLeftIcon />,
  arrowRight: <ArrowRightIcon />,
  clock: <ClockIcon />,
  tag: <TagIcon />,
  key: <KeyIcon />,
  login: <ArrowRightEndOnRectangleIcon />,
  calendar: <CalendarIcon />,
  globe: <GlobeAltIcon />,
  eye: <EyeIcon />,
  hidden: <EyeSlashIcon />,
  map: <MapIcon />,
  chart: <ChartBarIcon />,
};

const defaultIconStyling = ({ palette }) => ({
  height: 24,
  svg: {
    height: 24,
    width: 24,
    stroke: palette.grey[300],
    color: palette.grey[300],
    strokeWidth: 1,
    verticalAlign: 'middle',
  },
});

export const IconWrapper = ({ icon = '', sx = {}, height = 24, ...rest}) => {
  const theme = useTheme();
  const iconStyles = defaultIconStyling(theme);
  return icon ? (
    <Box sx={{...iconStyles, height}} {...rest}>
      <Box sx={sx}>{iconMap[icon]}</Box>
    </Box>
  ) : (
    <></>
  );
};
